/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PresetSystemActionSubject = {
    Preset: 'Preset'
} as const;
export type PresetSystemActionSubject = typeof PresetSystemActionSubject[keyof typeof PresetSystemActionSubject];


export function instanceOfPresetSystemActionSubject(value: any): boolean {
    for (const key in PresetSystemActionSubject) {
        if (Object.prototype.hasOwnProperty.call(PresetSystemActionSubject, key)) {
            if (PresetSystemActionSubject[key as keyof typeof PresetSystemActionSubject] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PresetSystemActionSubjectFromJSON(json: any): PresetSystemActionSubject {
    return PresetSystemActionSubjectFromJSONTyped(json, false);
}

export function PresetSystemActionSubjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): PresetSystemActionSubject {
    return json as PresetSystemActionSubject;
}

export function PresetSystemActionSubjectToJSON(value?: PresetSystemActionSubject | null): any {
    return value as any;
}

export function PresetSystemActionSubjectToJSONTyped(value: any, ignoreDiscriminator: boolean): PresetSystemActionSubject {
    return value as PresetSystemActionSubject;
}

